import { Button } from "./Button";
import { useDispatch } from "react-redux";
import { openSignup } from "../../redux/Reducers/modalReducer";
import mixpanel from "mixpanel-browser";
import { User, EventPageEvent } from "./VerifyUserInfo";
import { updatePostOnboardingData } from "../../utils/postOnboardingAction";
import { useNavigate } from "react-router-dom";
import { useUserInTribe } from "../../hooks/useUserInTribe";

interface Props {
  user: User | null;
  event: EventPageEvent;
  onJoinTribe: () => void;
  isPending?: boolean;
}

function JoinTribeButton({ user, event, onJoinTribe, isPending }: Props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isUserInTribe, isLoading } = useUserInTribe(event._id);

  function handleJoinTribeClick() {
    if (!user) {
      updatePostOnboardingData({
        action: "join_tribe",
        ticketUrl: null,
      });
      dispatch(openSignup({}));
      return;
    }

    mixpanel.track("Join Tribe", {
      "Event Name": event.event_name,
      "Event ID": event._id,
    });

    onJoinTribe();
  }

  function handleGetTicketsClick() {
    if (!user) {
      updatePostOnboardingData({
        action: "view_event",
        ticketUrl: event.tracking_url,
      });
      dispatch(openSignup({}));
      return;
    }

    mixpanel.track("Buy Ticket", {
      "Event Name": event.event_name,
      "Event ID": event._id,
    });

    window.open(event.tracking_url, "_blank");
  }

  return (
    <div>
      <div className="flex items-center gap-2 mt-4">
        <div style={{ boxSizing: "border-box" }}>
          {isUserInTribe ? (
            <Button
              onClick={() => navigate(`/chat`)}
              size="lg"
              variant={"default"}
            >
              Tribe Chat
            </Button>
          ) : (
            <Button
              onClick={handleJoinTribeClick}
              size="lg"
              variant={"default"}
              disabled={isUserInTribe || isPending || isLoading}
            >
              {isPending
                ? "Joining..."
                : isUserInTribe
                ? "Already Joined"
                : "Join Tribe"}
            </Button>
          )}
        </div>

        <div>
          <Button onClick={handleGetTicketsClick} variant={"yellow"} size="lg">
            GET TICKETS
          </Button>
        </div>
      </div>
    </div>
  );
}

export default JoinTribeButton;
